/**
 * dnd-kit integration for one block: draggable (via its handle) + droppable.
 */

import { useDraggable, useDroppable } from '@dnd-kit/core';

export const useBlockDragDrop = (block) => {
  // Rows/columns are layout containers — not draggable or droppable themselves
  const isContainer =
    block.type === 'row' || block.type === 'column' || block.type === 'choice-path';

  const { attributes, listeners, setNodeRef: setDragRef, transform, isDragging } = useDraggable({
    id: block.id,
    data: { block },
    disabled: isContainer,
  });

  const { setNodeRef: setDropRef, isOver } = useDroppable({
    id: `droppable-${block.id}`,
    data: { block },
    disabled: isContainer,
  });

  return {
    attributes,
    listeners,
    setDragRef,
    setDropRef,
    transform,
    isDragging,
    isOver,
  };
};
